export const getSellerInventorySummaryUrl =
  "/api/v3/seller/:sellerId/media/inventory/summary";
export const getSellerInfoByIdUrl = "/api/v3/seller/:sellerId";
export const searchSellerUrl = "/api/v3/seller/search?_kw=:searchText&_en=true";
export const updateSellerInfoUrl = "/api/v3/seller/:sellerId";
export const updateSellerLogoUrl = "/api/v3/seller/:sellerId/logo";
export const enableSellerSite = "/api/v3/seller/:sellerId/pages/enable";
export const disableSellerSite = "/api/v3/seller/:sellerId/pages/disable";
